import { svgIconClassName } from '@archipro-design/icons';
import type { StyleRule } from '@archipro-design/aria';
import { labelClassName } from '@archipro-design/aria';
import { pxToRem, pxArrayToRem } from '@archipro-design/aria';

export const Container: StyleRule = ({ theme }) => ({
    paddingTop: pxToRem(15),

    [theme.screen.laptop]: {
        paddingTop: pxToRem(120),
        gridGap: pxToRem(72),
    },
});

export const HeroContent: StyleRule = ({ theme }) => ({
    textAlign: 'center',
    cursor: 'default',
    marginTop: pxToRem(14),
    fontSize: pxToRem(14),
    lineHeight: pxToRem(18),
    padding: pxArrayToRem([0, 18]),

    [`& > *`]: {
        margin: 0,
        fontSize: 'inherit',
        lineHeight: 'inherit',
    },

    [theme.screen.laptop]: {
        textAlign: 'left',
        marginTop: 0,
        padding: 0,
        maxWidth: pxToRem(615),
        fontSize: pxToRem(16),
        lineHeight: pxToRem(21),
    },
});

export const HeroTitle: StyleRule = ({ theme }) => ({
    [`&.${labelClassName}`]: {
        color: theme.siteVariables.colors.charcoal['250'],
        margin: `0`,
        textTransform: `lowercase`,
        cursor: 'default',
        textAlign: 'center',
        ...theme.siteVariables.textStyles.Article.Roman55,
        padding: pxArrayToRem([0, 18]),
    },
});

export const HeroTitleCopyright: StyleRule = ({ theme }) => ({
    width: pxToRem(9),
    height: pxToRem(9),
    marginTop: pxToRem(3),
    marginLeft: pxToRem(-7),
    [`& > .${svgIconClassName}`]: {
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& svg': {
            overflow: 'visible',
        },
    },

    [theme.screen.laptop]: {
        width: pxToRem(18.56),
        height: pxToRem(18.56),
        marginTop: pxToRem(14),
        marginLeft: pxToRem(-10),
        borderWidth: '2px',
    },
});

export const PageHeader: StyleRule = ({ theme }) => ({
    padding: pxArrayToRem([28, 18, 0, 18]),

    [theme.screen.tablet]: {
        padding: pxArrayToRem([67, 0, 20, 50]),
        minHeight: pxToRem(244),
        display: 'grid',
        alignItems: 'end',
    },
});

export const PageHeaderInner: StyleRule = ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',

    [theme.screen.tablet]: {
        display: 'grid',
        gridTemplateColumns: `${pxToRem(924)} 1fr`,
        alignItems: 'flex-end',
    },
});

export const LeftPane: StyleRule = ({ theme }) => ({
    [theme.screen.tablet]: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        position: 'relative',
        paddingBottom: pxToRem(34),
    },
});

export const RightPane: StyleRule = ({ theme }) => ({
    marginTop: theme.siteVariables.spaces['space-16'],
    [theme.screen.tablet]: {
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'space-between',
        position: 'relative',
        margin: 0,
        [`& .${labelClassName}`]: {
            padding: 0,
            lineHeight: pxToRem(132),
            fontSize: pxToRem(120),
            textAlign: 'left',
            letterSpacing: '-0.015em', // not in aria
        },
    },
});
